import { OTA_VehType } from "./ota_vehtype.model";

//export enum enumVehFuelType {
//    vFuelType_Unknown = 0,
//    vFuelType_Unleaded = 18,
//    vFuelType_Diesel = 19,
//    vFuelType_PremiumUnleaded = 20,
//    vFuelType_Oil = 21,
//    vFuelType_Electric = 22
//}

export class OTA_Vehicle {
    public code: string;
    public codeContext: string;
    public vehicleExample: string;
    public vehType = new OTA_VehType();

    public fuelType: string;
    //public fuelType: enumVehFuelType;
    public doors: number;
    public seats: number;
    public bags: number;
    public transmission: string;
    public airCon: boolean;
    public vehicleImageRef: string;
    public minimumAge: number;

    //static fuelTypeDescription(fuelType: enumVehFuelType): string {
    //    var desc = "";

    //    switch (fuelType) {
    //        case enumVehFuelType.vFuelType_Diesel:
    //            desc = "Diesel";
    //            break;
    //        case enumVehFuelType.vFuelType_Electric:
    //            desc = "Electric";
    //            break;
    //        case enumVehFuelType.vFuelType_Oil:
    //            desc = "Oil";
    //            break;
    //        case enumVehFuelType.vFuelType_PremiumUnleaded:
    //            desc = "Premium Unleaded";
    //            break;
    //        case enumVehFuelType.vFuelType_Unknown:
    //            desc = "Unknown";
    //            break;
    //        case enumVehFuelType.vFuelType_Unleaded:
    //            desc = "Unleaded";
    //            break;
    //    }
    //    return desc;
    //}
}